export default __webpack_public_path__ + "static/media/Constancia-entrega-documentos-produbanco.3adeff63.docx";